// extracted by css-extract-rspack-plugin
export default {"container":"SegmentedControl-module__container","option":"SegmentedControl-module__option","active":"SegmentedControl-module__active"};